import { memo, type FC } from "react";
import type { PlaneCoordinate, ToScreenPoint } from "./CartesianPlane";
import styles from "./NumberedPointMarkers.module.css";

type NumberedPointMarkersProps = {
  coordinates: PlaneCoordinate[];
  toScreenPoint: ToScreenPoint;
};

// The deck's vertices as numbered markers (index + 1), the numbering every other view refers to.
const NumberedPointMarkers: FC<NumberedPointMarkersProps> = ({ coordinates, toScreenPoint }) =>
  coordinates.map((coordinate, index) => {
    const point = toScreenPoint(coordinate, index);

    return (
      point && (
        <div
          key={`${index}-${coordinate.x}-${coordinate.y}`}
          className={styles.point}
          style={{ left: point.pixelX, top: point.pixelY }}
        >
          {index + 1}
        </div>
      )
    );
  });

// Memoized: re-renders only when the vertices or the view change.
export default memo(NumberedPointMarkers);
